export enum BookingActionTypes {
  SET_CATEGORY = 'SET_CATEGORY',
  SET_CATEGORY_TRACKING_ID = 'SET_CATEGORY_TRACKING_ID',
  SET_TRAVELERS = 'SET_TRAVELERS',
  SET_RENTAL = 'SET_RENTAL',
  SET_TRIP_COST = 'SET_TRIP_COST',
  SET_EXCESS_AMOUNT = 'SET_EXCESS_AMOUNT',
  SET_RESIDENCE = 'SET_RESIDENCE',
  SET_GEOGRAPHICAL_ZONE = 'SET_GEOGRAPHICAL_ZONE',
  SET_MEANS_OF_TRAVEL = 'SET_MEANS_OF_TRAVEL',
  SET_START_DATE = 'SET_START_DATE',
  SET_END_DATE = 'SET_END_DATE',
  SET_BOOKING_CONFIRMATION_DATE = 'SET_BOOKING_CONFIRMATION_DATE',
  SET_POLICY_HOLDER_SALUTATION = 'SET_POLICY_HOLDER_SALUTATION',
  SET_POLICY_HOLDER_FIRST_NAME = 'SET_POLICY_HOLDER_FIRST_NAME',
  SET_POLICY_HOLDER_LAST_NAME = 'SET_POLICY_HOLDER_LAST_NAME',
  SET_POLICY_HOLDER_COMPANY = 'SET_POLICY_HOLDER_COMPANY',
  SET_POLICY_HOLDER_SAME_PERSON = 'SET_POLICY_HOLDER_SAME_PERSON',
  SET_POLICY_HOLDER_STREET = 'SET_POLICY_HOLDER_STREET',
  SET_POLICY_HOLDER_POSTAL_CODE = 'SET_POLICY_HOLDER_POSTAL_CODE',
  SET_POLICY_HOLDER_CITY = 'SET_POLICY_HOLDER_CITY',
  SET_POLICY_HOLDER_COUNTRY = 'SET_POLICY_HOLDER_COUNTRY',
  SET_POLICY_HOLDER_PHONE = 'SET_POLICY_HOLDER_PHONE',
  SET_POLICY_HOLDER_EMAIL = 'SET_POLICY_HOLDER_EMAIL',
  SET_POLICY_HOLDER_EMAIL2 = 'SET_POLICY_HOLDER_EMAIL2',
  SET_HAS_CONFIRMED_PRECONTRACTUAL_DOCUMENTS = 'SET_HAS_CONFIRMED_PRECONTRACTUAL_DOCUMENTS',
  SET_POLICY_HOLDER_ACCOUNT_HOLDER = 'SET_POLICY_HOLDER_ACCOUNT_HOLDER',
  SET_POLICY_HOLDER_IBAN = 'SET_POLICY_HOLDER_IBAN',
  SET_PERSONS = 'SET_PERSONS',
  SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD',
  SET_COVID_PROTECTION = 'SET_COVID_PROTECTION',
  SET_EXCESS = 'SET_EXCESS',
  SET_HIDE_JV = 'SET_HIDE_JV',
  SET_TRAVEL_CANCELLATION = 'SET_TRAVEL_CANCELLATION',
  SET_HAS_CONFIRMED_PAYMENT = 'SET_HAS_CONFIRMED_PAYMENT',
  SET_ERGO_ORGANISATION_UNIT = 'SET_ERGO_ORGANISATION_UNIT',
  SET_OENR1 = 'SET_OENR1',
  SET_WAY_OF_ACCESS = 'SET_WAY_OF_ACCESS',
  SET_DISPLAY_TRIP_COST = 'SET_DISPLAY_TRIP_COST',
  SET_DISPLAY_INDIVIDUAL_TRIP_COST = 'SET_DISPLAY_INDIVIDUAL_TRIP_COST',
  SET_AGENT = 'SET_AGENT',
}
